<template>
  <div class="alert alert-secondary">
    {{ msg }}
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorMessage',
  props: {
    msg: {
      type: String,
      default: 'Es ist ein unbekannter Fehler aufgetreten.'
    }
  }
});
</script>
